(function () {
  var logo = document.querySelector(".header__heading-logo-wrapper");
  var logoElement = document.querySelector(".brand-logo");
  var wrapper = document.querySelector(".brand-animation-wrapper");
  var headerWrapper = document.querySelector(".header-wrapper");
  var isHomePage =
    document.body.classList.contains("template-index") ||
    window.location.pathname === "/";
  var shopUsDropdown = document.querySelector(".shopus-dropdown-nav");
  var scrollThreshold = 50;
  var resetThreshold = 5;
  var isScrolling = false;
  var lastScrollY = 0;
  var headerStateVisible = false;

  var transitionStr = "transform 0.4s cubic-bezier(0.0, 0.0, 0.2, 1), opacity 0.4s cubic-bezier(0.0, 0.0, 0.2, 1)";
  
  if (!isHomePage || !logo || !headerWrapper) return;

  function setDropdownVisibility(visible, duration) {
    if (!shopUsDropdown) return;
    shopUsDropdown.style.transition = `opacity ${duration}s cubic-bezier(0.0, 0.0, 0.2, 1)`;
    shopUsDropdown.style.opacity = visible ? "1" : "0";
  }

  function showHeaderState(duration) {
    var colorScheme = headerWrapper.dataset.colorScheme;
    var gradient = headerWrapper.dataset.gradient;

    if (colorScheme) headerWrapper.classList.add(colorScheme);
    if (gradient) headerWrapper.classList.add(gradient);

    logo.style.transition = `transform ${duration}s cubic-bezier(0.0, 0.0, 0.2, 1), opacity ${duration}s cubic-bezier(0.0, 0.0, 0.2, 1)`;
    logo.style.transformOrigin = "center center";
    logo.style.opacity = "1";
    logo.style.transform = "scale(1)";

    setDropdownVisibility(true, duration);
    headerStateVisible = true;
  }

  function hideHeaderState(duration) {
    var colorScheme = headerWrapper.dataset.colorScheme;
    var gradient = headerWrapper.dataset.gradient;

    if (colorScheme) headerWrapper.classList.remove(colorScheme);
    if (gradient) headerWrapper.classList.remove(gradient);

    logo.style.transition = `transform ${duration}s cubic-bezier(0.0, 0.0, 0.2, 1), opacity ${duration}s cubic-bezier(0.0, 0.0, 0.2, 1)`;
    logo.style.transformOrigin = "center center";
    logo.style.opacity = "0";
    logo.style.transform = "scale(0.95)";

    setDropdownVisibility(false, Math.min(duration, 0.3));
    headerStateVisible = false;
  }

  function isQuickViewTransitioning() {
    return (
      document.body.classList.contains("qv-modal-open") ||
      document.body.classList.contains("qv-modal-transition")
    );
  }

  function handleHeaderOnlyScroll() {
    var scrollY = window.scrollY;

    if (Math.abs(scrollY - lastScrollY) < 2) return;
    lastScrollY = scrollY;

    if (scrollY > scrollThreshold && !headerStateVisible) {
      showHeaderState(0.6);
    } else if (scrollY <= resetThreshold && headerStateVisible) {
      hideHeaderState(0.4);
    }
  }

  function onHeaderOnlyScroll() {
    if (!isScrolling) {
      isScrolling = true;
      requestAnimationFrame(function () {
        handleHeaderOnlyScroll();
        isScrolling = false;
      });
    }
  }

  hideHeaderState(0);
  logo.style.transform = "scale(0.95)";

  if (!logoElement || !wrapper) {
    lastScrollY = window.scrollY;

    if (window.scrollY > scrollThreshold) {
      showHeaderState(0);
    }

    window.addEventListener("scroll", onHeaderOnlyScroll, { passive: true });
    return;
  }

  var animationTriggered = false;
  var isResetting = false;

  function resetAnimation() {
    if (isResetting) return;
    isResetting = true;
    animationTriggered = false;

    wrapper.classList.remove("hidden");
    wrapper.style.display = "flex";
    wrapper.style.opacity = "1";
    wrapper.style.position = "fixed";
    wrapper.style.pointerEvents = "auto";
    wrapper.style.visibility = "visible";

    // Logo element animation
    logoElement.style.transition = "transform 1.4s cubic-bezier(0.0, 0.0, 0.2, 1), opacity 1.4s cubic-bezier(0.0, 0.0, 0.2, 1)";
    logoElement.style.transformOrigin = "center center";
    logoElement.style.transform = "translate3d(0, 0, 0) scale(1) rotate(0deg)";
    logoElement.style.opacity = "1";

    // Logo block animation
    setTimeout(function () {
      logo.style.transition = "transform 0.8s cubic-bezier(0.0, 0.0, 0.2, 1), opacity 0.8s cubic-bezier(0.0, 0.0, 0.2, 1)";
      logo.style.transformOrigin = "center center";
      logo.style.opacity = "0";
      logo.style.transform = "scale(0.95)";
    }, 200);

    setTimeout(function () {
      hideHeaderState(0);
      logo.style.opacity = "0";
      logo.style.transform = "scale(0.95)";
      isResetting = false;
    }, 1400);
  }

  function animateToLogo() {
    if (animationTriggered || isResetting) return;
    animationTriggered = true;

    var logoRect = logo.getBoundingClientRect();
    var logoElementRect = logoElement.getBoundingClientRect();
    var deltaX =
      logoRect.left +
      logoRect.width / 2 -
      (logoElementRect.left + logoElementRect.width / 2);
    var deltaY =
      logoRect.top +
      logoRect.height / 2 -
      (logoElementRect.top + logoElementRect.height / 2);

    // Initial state
    logoElement.style.transition = "transform 0.8s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.8s cubic-bezier(0.32, 0, 0.67, 0)";
    logoElement.style.transformOrigin = "center center";
    logoElement.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.08) rotate(12deg)`;
    logoElement.style.opacity = "0";

    setTimeout(function() {
      wrapper.style.transition = "opacity 1.2s cubic-bezier(0.0, 0.0, 0.2, 1)";
      wrapper.style.opacity = "0";
      
      setTimeout(function() {
        wrapper.style.position = "static";
        wrapper.style.display = "none";
        wrapper.style.pointerEvents = "none";
        wrapper.style.visibility = "hidden";
        wrapper.classList.add("hidden");
      }, 1200);
    }, 200);
    
    setTimeout(function() {
      showHeaderState(0.6);
    }, 400);

    setTimeout(function() {
      logo.style.transition = "transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.8s cubic-bezier(0.0, 0.0, 0.2, 1)";
      logo.style.opacity = "1";
      logo.style.transform = "scale(1.12)";
      
      setTimeout(function() {
        logo.style.transition = "transform 0.5s cubic-bezier(0.0, 0.0, 0.2, 1)";
        logo.style.transform = "scale(1)";
      }, 600);
    }, 600);
  }

  function handleAnimatedScroll() {
    if (isQuickViewTransitioning()) return;

    var scrollY = window.scrollY;

    if (Math.abs(scrollY - lastScrollY) < 2) return;
    lastScrollY = scrollY;

    if (scrollY > window.innerHeight * 1.2) {
      wrapper.classList.add("hidden");
      wrapper.style.opacity = "0";
      wrapper.style.pointerEvents = "none";
      wrapper.style.visibility = "hidden";
    } else if (scrollY <= window.innerHeight) {
      wrapper.classList.remove("hidden");
      wrapper.style.visibility = "";
    }

    if (scrollY > scrollThreshold && !animationTriggered && !isResetting) {
      animateToLogo();
    } else if (
      scrollY <= resetThreshold &&
      animationTriggered &&
      !isResetting
    ) {
      resetAnimation();
    }

    if (scrollY <= resetThreshold) {
      hideHeaderState(0.3);
    }
  }

  function onAnimatedScroll() {
    if (!isScrolling) {
      isScrolling = true;
      requestAnimationFrame(function () {
        handleAnimatedScroll();
        isScrolling = false;
      });
    }
  }

  window.addEventListener("scroll", onAnimatedScroll, { passive: true });

  var heroSection = document.querySelector(
    ".shopify-section:first-child, .hero-section, .index-sections > section:first-child"
  );

  if (heroSection && window.IntersectionObserver) {
    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && animationTriggered) {
            wrapper.classList.add("hidden");
            wrapper.style.opacity = "0";
            wrapper.style.pointerEvents = "none";
            wrapper.style.visibility = "hidden";
          } else if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
            wrapper.classList.remove("hidden");
            wrapper.style.visibility = "";
          }
        });
      },
      {
        threshold: [0, 0.1],
        rootMargin: "0px 0px -50px 0px",
      }
    );

    heroObserver.observe(heroSection);
  }

  if (window.scrollY <= resetThreshold) {
    resetAnimation();
  } else if (window.scrollY > window.innerHeight) {
    wrapper.classList.add("hidden");
    wrapper.style.opacity = "0";
    wrapper.style.pointerEvents = "none";
    wrapper.style.visibility = "hidden";
  }

  document.addEventListener("visibilitychange", function () {
    if (isQuickViewTransitioning()) return;

    if (
      !document.hidden &&
      window.scrollY <= resetThreshold &&
      animationTriggered
    ) {
      setTimeout(resetAnimation, 100);
    }
  });
})();
